<style lang="postcss">
	.has-underline,
	.has-underline-left {
		position: relative;
		text-align: center;
	}
	.has-underline::before,
	.has-underline-left::before {
		content: "";
		display: block;
		position: absolute;
		margin: 0 auto;
		height: 3px;
		width: 4rem;
		bottom: -0.8rem;
		left: 50%;
		margin-left: -2rem;
		border-radius: 5px;
		background-color: currentColor;
	}
	.has-underline-left::before {
		left: 0;
		margin-left: 0;
	}
</style>

<script lang="ts">
	import Breadcrumbs from "$src/lib/Components/Basic/Breadcrumbs.svelte";
	import { page } from "$app/stores";

	let crumbs: Breadcrumb[] = [];
	$: createBreadcrumbs($page.data);

	function createBreadcrumbs(pageData: any) {
		crumbs = [];
		crumbs.push({
			text: "Addons",
			shortText: "Addons",
			link: "/addons"
		});
		if (pageData.post) {
			crumbs.push({
				text: pageData.post.name,
				link: `/addons/${pageData.post.slug}`
			});
		}
	}
</script>

<div
	class="flex flex-col items-stretch mx-auto w-full pt-4 pb-12 md:pt-10 max-w-5xl ml-0">
	<div class="text-sm">
		<Breadcrumbs data="{crumbs}" />
	</div>
	<div class="flex flex-col flex-1 h-full min-w-0 items-start mt-2">
		<slot />
	</div>
</div>
